import { render, staticRenderFns } from "./MobileDocumentMenu.vue?vue&type=template&id=4f7ee657&scoped=true"
import script from "./MobileDocumentMenu.vue?vue&type=script&lang=js"
export * from "./MobileDocumentMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_ec1e824a4fe600ca080e24d3f05cd390/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7ee657",
  null
  
)

export default component.exports